import { render, staticRenderFns } from "./OrderExpressDetail.vue?vue&type=template&id=089f2edf&scoped=true&"
import script from "./OrderExpressDetail.vue?vue&type=script&lang=js&"
export * from "./OrderExpressDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderExpressDetail.vue?vue&type=style&index=0&id=089f2edf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f2edf",
  null
  
)

export default component.exports